
// Backend URL configuration
const getBackendUrl = (): string => {
  if (process.env.NODE_ENV === 'development') {
    return process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/'
  }

  const backendUrl = process.env.REACT_APP_BACKEND_URL
  if (!backendUrl) {
    throw new Error("Missing environment variable: REACT_APP_BACKEND_URL")
  }
  return backendUrl
}

export const backendUrl = getBackendUrl()
